import React from 'react'
import PropTypes from 'prop-types'

/**
 * AppLayoutFooter Component
 *
 * A footer component that is positioned at the bottom of the page. It displays
 * a copyright notice on the left and a developer credit on the right.
 *
 * @module appLayout/AppLayout
 * @description A footer component that is positioned at the bottom of the page. It displays
 * a copyright notice on the left and a developer credit on the right.
 * @example
 * // Usage in a layout component
 * <AppLayoutFooter />
 *
 * @returns {React.ReactElement} The rendered footer component.
 */
export const AppLayoutFooter = ({ modSchema }) => {
  return modSchema.noLayout ? (
    <footer className="trtui-footer" style={{ position: 'fixed', bottom: 0, left: 0 }}>
      <div className="trtui-container-fluid">
        <div className="trtui-row">
          <div className="trtui-col-sm-6">© TRT.</div>
          <div className="trtui-col-sm-6">
            <div className="trtui-text-sm-end trtui-d-none trtui-d-sm-block">
              Developed by <strong>Thulisha Reddy Technologies</strong>
            </div>
          </div>
        </div>
      </div>
    </footer>
  ) : (
    <footer className="trtui-footer" style={{ position: 'fixed', bottom: 0 }}>
      <div className="trtui-container-fluid">
        <div className="trtui-row">
          <div className="trtui-col-sm-6">© TRT.</div>
          <div className="trtui-col-sm-6">
            <div className="trtui-text-sm-end trtui-d-none trtui-d-sm-block">
              Developed by <strong>Thulisha Reddy Technologies</strong>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

AppLayoutFooter.propTypes = {
  modSchema: PropTypes.object,
}
